import * as React from "react";
import { Grid, Button } from "semantic-ui-react";
import { get } from "lodash";

import { EditableField } from "@/components/Inputs/EditableField";
import { fromPrompt, SharedPostFlowDefaults } from "@/components/PostDialogs/SharedPostFlowDefaults";
import { PlayerPostDialog } from "@/components/PostDialogs/PlayerPostDialog";
import * as DTO from "../../../../../../../interfaces";

import "./styles.scss";
import { PromptCard } from "@/components/Cells/PromptCard";
import { isDynamicPrompt } from "@/containers/Coach/Library/PromptsTab/promptKind";
interface OwnProps {
  promptList: DTO.PlayerPrompt[];
  name: string;
  category?: DTO.Category;
  disable?: boolean;
  deliveryMode?: DTO.DeliveryMode;
  onOpenDynamicPrompt?: (prompt: DTO.Prompt) => void;
}

type Props = OwnProps;

const CategorySectionFC: React.FC<Props> = ({ category, promptList, name, onOpenDynamicPrompt }) => {
  const [display, setDisplay] = React.useState<boolean>(true);
  const [showPostModal, setShowPostModal] = React.useState<boolean>(false);
  const [selectedPrompt, setSelectedPrompt] = React.useState<DTO.Prompt | undefined>(undefined);

  const actionTitle = (): string => {
    if (!display) {
      return "Expand (" + promptList.length + ")";
    }
    return "Collapse (" + promptList.length + ")";
  };

  const postDefaults: SharedPostFlowDefaults | undefined = React.useMemo(() => {
    if (selectedPrompt) return fromPrompt(selectedPrompt);
    else return undefined;
  }, [selectedPrompt]);

  const categoryName = get(category, "categoryId", name);
  return (
    <Grid
      columns={3}
      data-elm-id={"library-list-element-" + categoryName}
      key={"library-list-element-" + categoryName}
      className={display ? "libraryListCategoryGrid" : "libraryListCategoryGrid collapsed"}
    >
      <Grid.Row columns={3} className={display ? "libraryListCategoryGrid" : "libraryListCategoryGrid collapsed"}>
        <EditableField
          headerType={"h2"}
          name={"playerLibraryCategoryId" + categoryName}
          currentValue={name}
          handleChangeValue={() => {}}
          disable={true}
        />

        <Grid.Column width={3} floated="right" className={"noBorder"}>
          <Button
            basic
            data-elm-id={`librarySectionDisplayBtn`}
            content={actionTitle()}
            icon={!display ? "triangle right" : "triangle down"}
            className={"noBorder floatRight"}
            labelPosition={"right"}
            onClick={() => setDisplay(!display)}
          />
        </Grid.Column>
      </Grid.Row>

      <div className={"flex gap-x-5 " + (display ? "flex-wrap" : "overflow-auto h-fit")}>
        {promptList.map((prompt, index) => {
          return (
            <PromptCard
              key={`player_library_prompt_card_${index}_${prompt.prompt.promptId}`}
              prompt={{ ...prompt.prompt, creationDate: prompt.deliveryDateTime }}
              onClick={() => {
                if (isDynamicPrompt(prompt.prompt)) {
                  onOpenDynamicPrompt?.(prompt.prompt);
                  return;
                }
                setShowPostModal(true);
                setSelectedPrompt(prompt.prompt);
              }}
            />
          );
        })}
      </div>
      {showPostModal && postDefaults && (
        <PlayerPostDialog
          open={showPostModal}
          handleClose={() => {
            setShowPostModal(false);
            setSelectedPrompt(undefined);
          }}
          defaults={postDefaults}
        />
      )}
    </Grid>
  );
};

export const CategorySection = CategorySectionFC;
